import { isAuthenticated } from "./identityUtils";
import sdkProvider from "../helpers/sdk-provider";

export const getSegmentIds = async () => {
  const isLoggedIn = await isAuthenticated();
  if (isLoggedIn) {
    try {
      const audience = await sdkProvider("audience");
      return await audience.getSegments();
    } catch (e) {
      return null;
    }
  }
  return null;
};
